module.exports = __webpack_public_path__ + "static/media/eyes_1f440.75849f75.png";